import { gql } from "@apollo/client";

// `profile` resolves the caller from their own token, so no id variable is needed.
export const getUserProfile = gql`
  query Tools_UserProfile {
    profile: profile {
      profile {
        auth_role {
          role
        }
        person {
          id
          email
          first_name
          last_name
          nickname
          avatar_uri
        }
        organisations {
          id
          name
          type
          avatar_uri
          deleted_at
          timezone
          has_ttp_data_access
          position {
            coordinates
          }
        }
      }
    }
  }
`

// `update_profile` resolves the caller from their own token, so no person id is
// needed. Returns the same shape as getUserProfile.
export const UpdateUserProfile = gql`
  mutation Tools_UpdateUserProfile($input: update_profile_input!) {
    update_profile(input: $input) {
      profile {
        person {
          id
          first_name
          last_name
          nickname
        }
      }
    }
  }
`
